<template>
  <table class="table table-borderless table-border table-align">
    <thead>
    <tr>
      <th>
        <BkpsCheckBox @input="$emit('changeCheckAllRow', $event)" :value="checkAllRow"/>
      </th>
      <th v-for="column in columns" :key="column.key">{{ column.label }}</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="ticket in tickets" :key="ticket.id">
      <td>
        <BkpsCheckBox v-model="ticket.checked" @input="$emit('changeCheckRow', $event)"/>
      </td>
      <td v-for="column in columns" :key="column.key">
        {{ resolveValue(ticket, column) }}
      </td>
      <td style="padding-left: 8px; padding-right: 16px;">
        <router-link
          :to="`/indicacao-condutores/details/${ticket.id}`"
          class="btn btn-outline btn-sm"
          title="Ver detalhes da indicação"
        >
          Detalhes
        </router-link>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
import GetUser from '@/mixins/GetUser'
import GetAccount from '@/mixins/GetAccount.vue'
import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'
import { IssuingAuthority } from '@/models/IssuingAuthority'
import { IBGE } from '@/models/ibge'
import Formatter from '@/models/Formatter'

export default {
  components: { BkpsCheckBox },
  mixins: [GetUser, GetAccount],
  name: 'DriverIndicationTable',
  props: {
    checkAllRow: { required: true, type: Boolean },
    columns: { required: true, type: Array },
    tickets: { required: true, type: Array },
    getStatusName: { required: true, type: Function }
  },
  methods: {
    isNoCrossing(indication) {
      const cpf = indication.ticket?.cpf
      const motorista = indication.driver?.name
      const categoria = indication.driver?.category
      return [cpf, motorista, categoria].every(val => !val || val === 'Não realizado cruzamento');
    },
    hasDriver(indication) {
      const cpf = indication.ticket?.cpf
      const motorista = indication.driver?.name
      const categoria = indication.driver?.category
      return [cpf, motorista, categoria].every(val => val && val !== 'Não realizado cruzamento');
    },
resolveValue(ticket, column) {
      let value = column.key.includes('.')
        ? ticket.dig(...column.key.split('.'))
        : ticket[column.key]

      if (value === null || value === undefined) {
        if (['ticket.cpf', 'driver.name', 'driver.category'].includes(column.key)) {
          return 'Não realizado cruzamento'
        }
        return '-'
      }

      if (column.filter) {
        if (column.filter === 'authority') {
          return IssuingAuthority.label(value) || value
        }
        return this.$options.filters[column.filter](value)
      }

      if (column.type === 'cpf' && value) {
        return Formatter.cpf(value)
      }

      if (column.type === 'cnpj' && value) {
        return Formatter.cnpj(value)
      }

      if (column.type === 'datetime' && value) {
        return this.$options.filters.datetime(value)
      }

      if (column.type === 'date' && value) {
        return this.$options.filters.date(value)
      }

      if (column.type === 'currency' && value !== null && value !== undefined) {
        const valueInReais = value / 100
        return this.$options.filters.currency(valueInReais)
      }

      if (column.type === 'cityCode' && value) {
        const city = IBGE.getByCityCode(value)
        return city ? city.name : value
      }

      if (column.key === 'driver_indication_status_id') {
        return this.getStatusName(ticket)
      }

      if (['ticketClass', 'ticketSubclass'].includes(column.key) && value === 'NIC') {
        return '-'
      }

      return value
    }
  }
}
</script>

<style scoped>
.table-align td {
  vertical-align: middle;
}
</style>
